import * as React from 'react';
import { Link } from 'react-router-dom';

// Assets

// Components
export default class LoginButton extends React.Component<{}, {}> {
    public render() {
        return <li className='nav-item'>
            <Link to='/frontend/login' className='nav-link login-button'>Login</Link>
        </li>;
    }
};
